/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import "moment-timezone";
import moment from "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CommonDateTime } from "../../Api/commonDateTime";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import EYE from "../../assets/image/EYE.svg";
import ReusableTable from "../UserInformation/ReusableTable";

export const OrderReport = () => {
  const { websocket } = useContext(WebSocketContext);
  const { OrderReportList, search, userId, formDate, toDate ,machineList,userList,recipientId,selfInfo} = useSelector(
    (state) => state.adminReducers
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [optionsRegion, SetOptionsRegion] = useState(() => machineList?.list?.filter((elm) => elm?.is_active)?.map((item, index) => ({ key: item?.id, value: item?.id, label: item?.machine_code })));
  const [optionForRecipient, setOrderForRecipient] = useState(() => userList?.list?.filter((elm) => elm?.is_active)?.map((item, index) => ({ key: item?.id, value: item?.id, label: item?.username })));
  const navigate = useNavigate();
    const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  useEffect(() => {
    // if (!formDate && !toDate) return 
    let param = { 
      "transmit": "single", 
      "url": "order_report_list", 
      "request" : { 
        "status" : "", 
        "limit" : "20", 
        "page_no" :search ? 1 : currentPage, 
        "search" : search ? search : "",
        "order_by" :"-updated_at",
        "recipient_id":recipientId ? recipientId :"",
        "machine_id":userId ? userId: ""
      } }
    if (formDate && toDate) {
      param.request.from_date =
        CommonDateTime(formDate, "YYYY-MM-DD", "hide") +" " + CommonDateTime(formDate, "HH:mm", "show");
      const formattedToDate =CommonDateTime(toDate, "YYYY-MM-DD", "hide") + " " +(CommonDateTime(toDate, "HH:mm", "show") === "00:00" ? "23:59" : CommonDateTime(toDate, "HH:mm", "show"));
      param.request.to_date = formattedToDate;
    }else{
        param.request.from_date =
        CommonDateTime(firstDayOfMonth, "YYYY-MM-DD", "hide") +" " + CommonDateTime(firstDayOfMonth, "HH:mm", "show");
      const formattedToDate =CommonDateTime(today, "YYYY-MM-DD", "hide") + " " +(CommonDateTime(today, "HH:mm", "show") === "00:00" ? "23:59" : CommonDateTime(today, "HH:mm", "show"));
      param.request.to_date = formattedToDate;
    }
    wsSend_request(websocket, param);
  }, [websocket, currentPage, userId, search, formDate, toDate,recipientId]);
  useEffect(() => {
    const payload = {
      transmit: "single",
      url: "machine_list",
      request: {
        status: "",
        limit: "2000",
        page_no: 1,
        search: "",
        recipient_id: selfInfo?.user_type!=="super_admin" ?  selfInfo?.id :"",
        order_by: "-updated_at",
      },
    };
        const payload2 = {
          transmit: "single",
          url: "user_list",
          request: {
            status: "",
            user_type: "recipient",
            limit: "20",
            page_no: "1",
            search: "",
            order_by: "-updated_at",
          },
        };
        wsSend_request(websocket, payload);
        if(selfInfo?.user_type==="super_admin"){
          wsSend_request(websocket, payload2);
        }
    
  }, [websocket]);

  const currentFunction = (page) => {
    setCurrentPage(page);
  };
  const headers = [
    { name: "Start Date", key: "start_date" },
    { name: "End Date", key: "end_date" },
      ...(selfInfo?.user_type === "super_admin"
    ? [{ name: "Recipient Name", key: "Recipient_Name" }]
    : [{
      name: "Machine Name", key: "machine_name"
    }]),
    // { name: "Recipient Name", key: "Recipient_Name" },
    { name: "Machine ID", key: "Machine_ID" },
    { name: "Total Captured (MYR)", key: "c_myr" },
    { name: "Total Reversed (MYR)", key: "r_myr" },
    { name: "Action", key: "Action" },
  ];

  const renderRow = (order, index, visibleColumns) => {
    return (
      <React.Fragment key={index}>
        <tr className="user-management-table-detail">
          {visibleColumns?.includes("start_date") && (
            <td style={{ cursor: "default" }}>
              {moment(order?.from_date).format("YYYY-MM-DD")}
            </td>
          )}
          {visibleColumns?.includes("end_date") && (
            <td style={{ cursor: "default" }}>
              {moment(order?.to_date).format("YYYY-MM-DD")}
            </td>
          )}
          {visibleColumns?.includes("Recipient_Name") && (
            <td>{order?.recipient_name ? order?.recipient_name : "-"}</td>
          )}
          {visibleColumns?.includes("machine_name") && (
            <td>{order?.machine_name ? order?.machine_name : "-"}</td>
          )}
          {visibleColumns?.includes("Machine_ID") && (
            <td>{order?.machine_code ? order?.machine_code : "-"}</td>
          )}
          {visibleColumns?.includes("c_myr") && (
            <td>{order?.total_amount ? order?.total_amount : "-"}</td>
          )}
          {visibleColumns?.includes("r_myr") && (
            <td>{order?.revers_amount ? order?.revers_amount : "-"}</td>
          )}
          {visibleColumns?.includes("Action") && (
            <td style={{ cursor: "default" }}>
              <span
                className="detail-icon"
                onClick={() => navigate("/view-report/" + order?.machine_id)}
              >
                <img src={EYE} alt="edit" title="View" />
              </span>
            </td>
          )}
        </tr>
      </React.Fragment>
    );
  };

  return (
    <div>
      <ReusableTable
        headers={headers}
        data={OrderReportList?.machines || []}
        paginationObject={OrderReportList?.pagination}
        renderRow={renderRow}
        filters={{
          fromDate: true,
          toDate: true,
          period: false,
          search: true,
          searchPlaceholder:selfInfo?.user_type === "super_admin" ?  "Search by Recipient Name, Machine ID" :"Search by Machine ID, Machine Name",
          userSelect: true,
          userOptions: optionsRegion,
          userFilterlabel:"Machine ID",
          userActive: false,
          userOptionsForActive: [],
          userRecipient: selfInfo?.user_type==="super_admin" ? true:false,
          userOptionsForRecipient: optionForRecipient,
          export: true,
          reset: true,
        }}
        currentPage={currentPage}
        handlePageChange={currentFunction}
      />
    </div>
  );
};

export default OrderReport;
